"use client";

import { Vacancy, VacancyCard } from "@entities/vacancy";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { ButtonLink, TVacancyRecommendationSection } from "@shared/cms";
import { Button, Carousel, CarouselApi, CarouselContent, CarouselItem } from "@ubud-ui/react-ui-kit";
import { useEffect, useState } from "react";

export function VacancyRecommendationSectionContent({ data, meta }: { data: Vacancy[]; meta: TVacancyRecommendationSection }) {
  const [api, setApi] = useState<CarouselApi>();
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (!api) return;

    const onSelect = () => {
      setCurrentSlide(api.selectedScrollSnap() + 1);
    };

    onSelect();

    api.on("select", onSelect);

    return () => {
      api.off("select", onSelect);
    };
  }, [api]);

  const handlePrevSlide = () => {
    if (!api) return;

    api.scrollPrev();
  };

  const handleNextSlide = () => {
    if (!api) return;

    api.scrollNext();
  };

  if (!data || (data && data.length <= 0)) {
    return <></>;
  }

  return (
    <section className="sm:py-10">
      <div className="sm:container">
        <div
          className="py-10 sm:py-14 flex flex-col md:flex-row md:items-center bg-primary sm:rounded-xl md:space-x-14 border border-grey-100 bg-contain bg-no-repeat"
          style={{
            backgroundImage: "url(/vacancies-recommendation-bg.webp)",
          }}
        >
          <div className="text-white max-w-72 ml-6 md:ml-10">
            <div>
              <div className="text-2xl sm:text-4xl font-bold">{meta.title}</div>
              <div className="mt-4 mb-5 text-gray-50">{meta.description}</div>
              <ButtonLink {...meta.moreButton} />
            </div>
            <div className="mt-8 flex space-x-2">
              <Button className="font-bold text-sm rounded-full size-10 text-gray-800" variant="outline" onClick={handlePrevSlide}>
                <ArrowLeftIcon className="size-5" />
              </Button>
              <Button className="font-bold text-sm rounded-full size-10 text-gray-800" variant="outline" onClick={handleNextSlide}>
                <ArrowRightIcon className="size-5" />
              </Button>
            </div>
          </div>
          <div className="flex-1 overflow-hidden mt-8 md:mt-0">
            <Carousel className="w-full" opts={{ align: "start" }} setApi={setApi}>
              <CarouselContent className="ml-0 mr-6 md:mr-10">
                {data.map((item, index) => {
                  return (
                    <CarouselItem key={item.title + "-" + index} className="pl-6 basis-[85%] sm:basis-[40%] md:basis-[80%] lg:basis-[43%]">
                      <VacancyCard vacancy={item} meta={meta.vacancyCard} />
                    </CarouselItem>
                  );
                })}
              </CarouselContent>
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
}
